export default __webpack_public_path__ + "static/media/comparison.d6fe6e1b.jpg";